export enum GUEST_STATUS {
  JOINED = 'Pending',
  PENDING = 'Joined',
  MISSED = 'Missed'
}

export enum ENUM_ITEM_TYPE {
  FOOD = 'FOOD',
  SHOP = 'SHOP',
  ALL = 'ALL'
}

export enum ENUM_BANK_NAMES {
  ACCESS = 'Access Bank',
  GT = 'GT Bank',
  WEMA = 'Wema Bank',
  PROVIDUS = 'Providus Bank',
  HERITAGE = 'Heritage Bank',
  FCMB = 'FCMB',
  '9PSB' = '9 Payment Service Bank',
  STANBIC = 'Stanbic Bank'
}
export enum BUDGET_SETTINGS_ENUM {
  RECURRING = 'RECCURRING',
  ROLL_OVER = 'ROLLOVER',
  ONE_OFF = 'ONE OFF'
}

export enum ENUM_MEMBER_FILTER_LIST {
  ALL = 'All',
  TOP_SPENDERS = 'Top spenders',
  LEAST_ORDERS = 'Least orders',
  RECENTLY_ADDED = 'Recently added',
  JOINED = 'Joined',
  PENDING_INVITE = 'Pending invite'
}

export enum ENUM_EVENT_FILTER_LIST {
  ALL = 'All',
  ACTIVE = 'Active',
  INACTIVE = ' Inactive',
  COMPLETED = 'Completed',
  MOST_RECENT = 'Most recent',
  LOW_TO_HIGH_BUDGET = 'Budget (Low to High)',
  HIGH_TO_LOW_BUDGET = 'Budget (High to Low)'
}

export enum ENUM_NOTIFICATION_FILTERS {
  TODAY = 'Today',
  THIS_WEEK = 'This week',
  LAST_WEEK = 'Last week',
  THIS_MONTH = ' This Month'
}

export enum ENUM_ORDER_STATUS {
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
  ONGOING = 'ongoing',
  RECURRING = 'recurring',
  SCHEDULED = 'scheduled',
  REJECTED = 'rejected',
  PENDING = 'pending'
}

export enum ENUM_ORDERS_TYPE {
  GROUP = 'group',
  BULK = 'bulk',
  BATCH = 'batch'
}

export enum ENUM_SELECTION_TYPE {
  SINGLE_SELECTION = 'SINGLE_SELECTION',
  MULTI_SELECTION = 'MULTI_SELECTION',
  MULTI_SELECTION_WITH_QUANTITY = 'MULTI_SELECTION_WITH_QUANTITY'
}

export enum ENUM_CATEGORY {
  SHOP = 'shop',
  FOOD = 'food'
}

export enum ENUM_ORDER_PROGRESS {
  PAYMENT_RECEIVED = 'Payment received',
  PREPARING_YOUR_ORDER = 'Preparing your order',
  AWAITING_RIDER = 'Awaiting rider to be assigned',
  ORDER_IN_TRANSIT = 'Order in transit',
  READY_FOR_PICKUP = 'Ready for pick up',
  ORDER_COMPLETED = 'Order completed'
}

export enum ENUM_ORDER_PAYMENT_TYPE {
  CASH = 'CASH',
  CARD = 'CARD',
  WALLET = 'WALLET'
}

export enum ENUM_EVENT_STATUS {
  INACTIVE = 'Inactive',
  COMPLETED = 'Completed',
  ACTIVE = 'Active'
}

export enum ENUM_DAY {
  Sunday = 1,
  Monday = 2,
  Tuesday = 3,
  Wednesady = 4,
  Thursday = 5,
  Friday = 6,
  Saturday = 7
}

export enum FCB_BATCH_ORDER_STATUS {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  ONGOING = 'ONGOING'
}

export enum ENUM_ONBOARDING_STEP {
  ADD_COMPANY_INFO = 'add_company_info',
  ADD_DEPARTMENT = 'add_department',
  ADD_MEMBER = 'add_member',
  ADD_BRANCH_ADDRESSES = 'add_branch_address',
  SET_OPERATIONAL_DAYS = 'set_operational_days',
  TOP_UP_WALLET = 'top_up_wallet',
  ASSIGN_ADMIN = 'assign_admin'
}

export enum ENUM_ONBOARDING_STATUS {
  PENDING = 'pending',
  COMPLETED = 'completed',
  SKIPPED = 'skipped'
}

export enum ENUM_BRAND_TYPE {
  FOODCOURT = 'foodcourt',
  CHOWDECK = 'chowdeck',
  FOODCOURT_BUSINESS = 'foodcourt_business',
  FCB_CUSTOM_BREAKFAST = 'fcb_custom_breakfast',
  FCB_CUSTOM_LUNCH = 'fcb_custom_lunch',
  FCB_CUSTOM_AFTERHOURS = 'fcb_custom_afterhours'
}
